import { MeetingApiParams } from '../components/_events/_manage-event/shared/connections-list/_connection-form/connection-form.viewmodel';
import { IMeetingConnectionRequestParams } from './connections.dao';
import { IMeetingRequestParams } from './meetings.dao';

abstract class IPodiumDAO {
    abstract getPodium(requestParams: IMeetingRequestParams): Promise<IPodiumDTO>;
    abstract createPodium(requestParams: IMeetingRequestParams): Promise<IPodiumDTO>;
    abstract updatePodium(requestParams: IPodiumUpdateRequestParams): Promise<IPodiumDTO>;
    abstract getQuestionsAuditLogCSV(params: IMeetingRequestParams): Promise<void>;
    abstract getPodiumLink(requestParams: MeetingApiParams): Promise<IPodiumLink>;
}

enum PodiumAccessType {
    oeCentralSignIn = 'oeCentralSignIn',
    openRegistration = 'openRegistration',
}

interface IPodiumDTO {
    podiumLinkEnabled: boolean;
    podiumLink?: string;
    podiumPresenterViewEnabled: boolean;
    podiumPresenterViewLink?: string;
    podiumAccessType: PodiumAccessType;
    podiumQuestionAnswerEnabled: boolean;
    podiumParticipantsEnabled: boolean;
    podiumAttendeesEnabled: boolean;
    podiumParticipantsLabel?: string | null;
    podiumControlSlidesEnabled: boolean;
    podiumChatEnabled: boolean;
    podiumControlSlidesLink: string;
    podiumDisconnectEnabled: boolean;
}

type IPodiumUpdateRequestParams = IMeetingConnectionRequestParams
    & Omit<IPodiumDTO, 'podiumPresenterViewEnabled'>
    & { podiumPresenterViewEnabled?: boolean };

type TPodiumAccessTypeLabel = {
    value: PodiumAccessType;
    label: string;
};

type IPodiumLink = {
    podiumLink: string;
};

export {
    IPodiumDAO,
    IPodiumDTO,
    IPodiumUpdateRequestParams,
    PodiumAccessType,
    TPodiumAccessTypeLabel,
    IPodiumLink,
};